// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BridgeController from "./bridge_controller"
application.register("bridge", BridgeController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ConfettiController from "./confetti_controller"
application.register("confetti", ConfettiController)

import FavoriteController from "./favorite_controller"
application.register("favorite", FavoriteController)

import FieldController from "./field_controller"
application.register("field", FieldController)

import FormController from "./form_controller"
application.register("form", FormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HelpersController from "./helpers_controller"
application.register("helpers", HelpersController)

import LinesController from "./lines_controller"
application.register("lines", LinesController)

import MapController from "./map_controller"
application.register("map", MapController)

import MapsController from "./maps_controller"
application.register("maps", MapsController)

import MessagesController from "./messages_controller"
application.register("messages", MessagesController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PageController from "./page_controller"
application.register("page", PageController)

import SignatureController from "./signature_controller"
application.register("signature", SignatureController)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)
